import React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import Card from '../../../components/Card/Card';

// eslint-disable-next-line react/display-name
const PageEditorWrapper = (WrappedComponent) => (props) => {
  if (!props.fields) {
    if (props.sitecoreContext.pageEditing) {
      return (
        <div className="sheet section py-4">
          <Card
            className="content-widget-icon mx-auto py-3 px-1"
            style={{ borderColor: 'red', background: '#ffa3a3' }}
          >
            <h2 className="text-title m-0 content-widget-icon__text text-center">
              Datasource is not set
            </h2>
            <h3 className="text-title m-0 content-widget-icon__text text-center">
              Please add a datasource to make the component be shown.
            </h3>
          </Card>
        </div>
      );
    }
    return null;
  }

  return <WrappedComponent {...props} />;
};

export default (WrappedComponent) => withSitecoreContext()(PageEditorWrapper(WrappedComponent));
